import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import FilteringSidePanel from "../../../../../shared/oversight-core/shared-components/filtering-side-panel/filtering-side-panel";
import AppDatePicker from "../../../../../shared/oversight-core/ui-elements/app-date-picker/app-date-picker";
import { formatDateByZoneId } from "../../../../../shared/oversight-core/utils/date-utils";

interface IProps {
  showFilter: boolean;
  onClose: () => void;
  onFilter: (startDate: string, endDate: string) => void;
}

const EstimationFilterSidePanel = (props: IProps) => {
  const { showFilter, onClose, onFilter } = props;

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const zoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <FilteringSidePanel
      isOpen={showFilter}
      onClose={() => {
        onClose();
        setStartDate(new Date());
        setEndDate(new Date());
      }}
      onFilter={() => {
        onFilter(
          formatDateByZoneId(startDate, zoneId),
          formatDateByZoneId(endDate, zoneId, "end")
        );
        onClose();
      }}
      onClearAll={() => {
        onFilter("", "");
        setStartDate(new Date());
        setEndDate(new Date());
        onClose();
      }}
    >
      <Row className="mt-2 flex-column">
        <Col>
          <Row className="flex-column">
            <Col className="font-size-14 font-eight-400 text-light">From</Col>
            <Col>
              <AppDatePicker
                selectedDate={startDate}
                onChange={(date: Date) => {
                  setStartDate(date);
                }}
                fontSize={12}
                dateFormat="dd/MM/yyyy"
              />
            </Col>
          </Row>
        </Col>
        <Col className="mt-4">
          <Row className="flex-column">
            <Col>
              <Col className="font-size-14 font-eight-400 text-light">To</Col>
            </Col>
            <Col>
              <AppDatePicker
                selectedDate={endDate}
                onChange={(date: Date) => {
                  setEndDate(date);
                }}
                fontSize={12}
                dateFormat="dd/MM/yyyy"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </FilteringSidePanel>
  );
};

export default EstimationFilterSidePanel;
